import ApplicationController from './application_controller'

/*
 * Generic controller to toggle an actions container based on selected items.
 *
 * CHECKBOXES EXAMPLE:
 * <div data-controller="selection-toggle">
 *   <div data-selection-toggle-target="actions" class="hidden">
 *     <button type="submit">Delete</button>
 *   </div>
 *   <input type="checkbox"
 *          data-selection-toggle-target="checkbox"
 *          data-action="change->selection-toggle#toggle" />
 *   <input type="checkbox"
 *          data-selection-toggle-target="checkbox"
 *          data-action="change->selection-toggle#toggle" />
 * </div>
 *
 * OTHER INPUTS EXAMPLE (e.g. select):
 * <div data-controller="selection-toggle">
 *   <div data-selection-toggle-target="actions" class="hidden">
 *     <button type="submit">Apply</button>
 *   </div>
 *   <select data-selection-toggle-target="checkbox"
 *           data-action="change->selection-toggle#toggle">
 *     <option value="">Choose...</option>
 *     <option value="foo">Foo</option>
 *   </select>
 * </div>
 */

export default class extends ApplicationController {
  static targets = ['checkbox', 'actions']

  connect () {
    this.updateVisibility()
  }

  toggle () {
    requestAnimationFrame(() => this.updateVisibility())
  }

  updateVisibility () {
    const hasSelection = this.checkboxTargets.some((checkbox) => checkbox.checked)
    this.actionsTarget.classList.toggle('hidden', !hasSelection)
  }

  export (event) {
    event.preventDefault()
    const params = this.checkboxTargets
      .filter(cb => cb.checked)
      .map(cb => `${encodeURIComponent(cb.name)}=${encodeURIComponent(cb.value)}`)
      .join('&')
    window.location.href = `${event.currentTarget.dataset.exportUrl}?${params}`
  }
}
